import LoLExamFooterLayout from './LoLExamFooterLayout';

export default LoLExamFooterLayout;
